<aslib-title Text="Relatório de Liquidação" SubText=" " Icon="fa fas fa-table"></aslib-title>
<router-outlet></router-outlet>

<div class="card-block">
  <div class="row">
    <div class="col-md-2">

      <button id="btnFiltro" type="button" class="btn btn-sm btn-primary" (click)="definirFiltro(filtroRel)">
        <aslib-icon icon="fa fa-filter"></aslib-icon>Filtro
      </button>

    </div>

    <div class="col-md-10 text-right">
      <button id="btnBaixarPDF" type="button" class="btn btn-sm btn-primary" [disabled]="disabledBtnExportRel"
        (click)="baixarRelatorio('')">
        <aslib-icon icon="fa fa-file-pdf-o"></aslib-icon>Baixar PDFs
      </button>

      <button id="btnBaixarExcel" type="button" class="btn btn-sm btn-primary ml-2" [disabled]="disabledBtnExportRel"
        (click)="baixarRelatorio('Excel')">
        <aslib-icon icon="fa fa-file-excel-o"></aslib-icon>Baixar Excel
      </button>

      <button id="btnExportarRel" type="button" class="btn btn-sm btn-primary" [disabled]="disabledBtnExportRel"
        (click)="exportarRelatorioPdf()">
        <aslib-icon icon="fa fa-th-list"></aslib-icon>Listagem
      </button>
    </div>
  </div>

  <!-- Div para apresentação do filtro de consulta. -->
  <ng-template #filtroRel>
    <gpa-filtro-rel-liquidacao [filtro]="filtro"></gpa-filtro-rel-liquidacao>
  </ng-template>

  <!-- Div para apresentação do detalhe da liquidação. -->
  <ng-template #detalheLiq>
    <gpa-detalhe-liquidacao [liquidacao]="itemSelecionado"></gpa-detalhe-liquidacao>
  </ng-template>

  <aslib-grid #grid id="grid" name="grid"  headerTitle="Relatório de liquidação" [(dataset)]="listagem"
    indexColumnVisible="true" limit="10">

    <aslib-grid-column [property]="'download'" [width]="40" [sortable]="false" [resizable]="false"
      class="text-center">
      <ng-template #AslibGridHeader let-item="item"><input type="checkbox" id="selecionaTodos" (change)="onCheckboxSelectAll($event)"></ng-template>
      <ng-template #AslibGridCell let-item="item">
        <input type="checkbox" id="{{item.numeroLiq | pedEmpLiq }}|{{item.seqItem}}|{{item.numeroProcessoSei}}" (change)="onCheckboxGrid($event)" [checked]="item.selecionado">
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'dataEnvioLiq'" header="Data da LIQ" class="text-center" [width]="90"
      [sortable]="true" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.dataEnvioLiq | date:'dd/MM/yyyy'}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'numeroLiq'" header="Nº da LIQ" [width]="175" [sortable]="true" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.numeroLiq | pedEmpLiq}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'valorLiq'" header="Valor da LIQ" class="text-right" [width]="120" [sortable]="true"
      [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.valorLiq | currency:'BRL'}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'numeroPed'" header="Nº do PED" [width]="175" [sortable]="true" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.numeroPed | pedEmpLiq}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'numeroEmp'" header="Nº do EMP" [width]="175" [sortable]="true" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.numeroEmp | pedEmpLiq}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'numeroProcessoSei'" header="Nº do Processo SEI" [width]="190" [sortable]="false"
      [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.numeroProcessoSei | processoSei}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'codigoCredor'" header="Código do Credor" [width]="100" [sortable]="false"
      [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.codigoCredor | credor}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="80" [sortable]="false" [resizable]="false"
      class="text-center">
      <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
      <ng-template #AslibGridCell let-item="item">
        <button type="button" class="btn btn-sm btn-primary" title="Exibir Detalhes"
          ascas-data="Exibir detalhamento da liquidação" (click)="exibirDetalhes(detalheLiq, item)">
          <aslib-icon type="1" icon="fa fa-eye"></aslib-icon>
        </button>
        <button type="button" class="btn btn-sm btn-primary" title="Gerar relatório individual"
          ascas-data="Gerar relatório individual de liquidação" (click)="gerarRelatorioIndividual(item)">
          <aslib-icon type="1" icon="fa fa-file-pdf-o"></aslib-icon>
        </button>
      </ng-template>
    </aslib-grid-column>

  </aslib-grid>

</div>


// WEBPACK FOOTER //
// ./src/app/pagamento/relatorios/rel-liquidacao/rel-liquidacao.component.html